import { getCaptions } from "../../../utils/helperFunctions";

export const getUniqeRowsHandler = (data) => {
    let array = [];
    let eleArray = [];
    data.forEach((element, index, ownArray) => {
        let filteredEleArray = eleArray?.filter(col => col?.[1]?.id === element?.ColData?.[1].id);
        // eleArray.forEach(col => console.log("asdsadasd",col))
        if(eleArray.length === 0){
            eleArray.push(element?.ColData)
        }else if(filteredEleArray.length === eleArray.length){
            // console.log("sda", element.ColData)
            eleArray.push(element?.ColData)
        }else{
            array.push(eleArray);
            eleArray = [];
            eleArray.push(element?.ColData)
        }
        if(ownArray.length -1 === index){
            array.push(eleArray);
            eleArray = [];
            eleArray.push(element?.ColData)
        }
    });
    return array;
}
export const getGrorpedTitle = (accountName, groupedData) => {
    const find = groupedData.find(data => data.accountName === accountName);
    return {
        head: find?.head || "",
        row: find?.row || ""
    }
}

export function getAccountNameOnly(name) {
    return name.replace(/^\s*[\d.]+[a-zA-Z]?\s*/, "");
}

export const uniqueRowsFormatter = (data) =>{
    return data?.map((JournalEntry, index)=>{
        let dateRaw = new Date(JournalEntry[0][0]?.value);
        let transactionType = JournalEntry[0][1]?.value;
        let number = JournalEntry[0][2]?.value;
        let date = `${dateRaw?.getFullYear()}-${(dateRaw?.getMonth()+1)?.toString()?.padStart(2, '0')}-${dateRaw?.getDate()?.toString()?.padStart(2, '0')}`;
        let debitRows = JournalEntry?.filter(col => !!col[col.length-2]?.value)?.map(col => (
            {date: date, accountName: getAccountNameOnly(col[col.length-3]?.value), accountCode: col[col.length-4]?.value, debit: col[col.length-2]?.value, credit:  col[col.length-1]?.value}
        ));
        let creditRows = JournalEntry?.filter(col => !!col[col.length-1]?.value)?.map(col => ({date: date, accountName: getAccountNameOnly(col[col.length-3]?.value), accountCode: col[col.length-4]?.value, debit: col[col.length-2]?.value, credit:  col[col.length-1]?.value}));
        let splitedRows;
        if(debitRows?.length === 1 && creditRows?.length === 1){
            splitedRows = debitRows?.map(col => {
                return [
                    {...col,},
                    {...creditRows[0]}
                ];
            });
        }else if ((debitRows?.length > 1 || creditRows?.length > 1) && !(debitRows?.length > 1 && creditRows?.length > 1)){
            if(debitRows?.length > 1){
                splitedRows = debitRows?.map(col => {
                    return [
                        {
                            ...col,
                        },
                        {
                            ...col,
                            credit: Math.round(col.debit),
                            debit: "",
                            accountName: creditRows[0]?.accountName
                        }
                    ]
                })
            }else{
                splitedRows = creditRows.map(col => {
                    return [
                        {
                            ...col,
                            debit: Math.round(col.credit),
                            credit: "",
                            accountName: debitRows[0]?.accountName,
                        },
                        {
                            ...col,
                        }
                    ]
                })
            }
        }else{
            splitedRows = []
        }
        return {
            date,
            transactionType,
            number,
            debitRows,
            creditRows,
            splitedRows
        }
    })
} 

export const splitDataHandler = (data, groupedData, entriesType, masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, MMMSplitSavedEntries) => {
    // All entries functionality
    const modifiedData = data?.map((JournalEntry, index)=>{
        let dateRaw = new Date(JournalEntry[0][0].value);
        let transactionType = JournalEntry[0][1].value;
        let number = JournalEntry[0][2].value;
        let date = `${(dateRaw.getMonth()+1).toString().padStart(2, '0')}-${dateRaw.getDate().toString().padStart(2, '0')}-${dateRaw.getFullYear()}`;
        let debitRows = JournalEntry.filter(col => !!col[col.length-2].value).map(col => (
            {date: date, accountName: col[col.length-3].value, debit: col[col.length-2].value, credit:  col[col.length-1].value}
        ));
        let creditRows = JournalEntry.filter(col => !!col[col.length-1].value).map(col => ({date: date, accountName: col[col.length-3].value, debit: col[col.length-2].value, credit:  col[col.length-1].value}));

        let splitedRows = [];
        if(debitRows.length === 1 && creditRows.length === 1){
            let debitRowHead = getGrorpedTitle(debitRows[0].accountName, groupedData);
            let creditRowHead = getGrorpedTitle(creditRows[0].accountName, groupedData);
            let {indirectMethod, directMethod} = getCFSMethodsInfo(debitRows[0].accountName, creditRows[0].accountName, masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData);
            // console.log({debitRowHead})
            // console.log()
            // splitedRows = [[...debitRows, ...creditRows]];
            splitedRows = debitRows.map(col => {
                return [
                    {...col, ...debitRowHead, indirectMethod, directMethod},
                    {...creditRows[0], ...creditRowHead}
                ];
            });
        }else if((debitRows.length > 1 || creditRows.length > 1) && !(debitRows.length > 1 && creditRows.length > 1)){
            if(debitRows.length > 1){
                splitedRows = debitRows.map(col => {
                    let debitRowHead = getGrorpedTitle(col.accountName, groupedData);
                    let creditRowHead = getGrorpedTitle(creditRows[0].accountName, groupedData);
                    let {indirectMethod, directMethod} = getCFSMethodsInfo(col.accountName, creditRows[0].accountName ,masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData);

                    return [
                        {
                            ...col,
                            ...debitRowHead,
                            indirectMethod,
                            directMethod
                        },
                        {
                            ...col,
                            ...creditRowHead,
                            credit: Math.round(col.debit),
                            debit: "",
                            accountName: creditRows[0].accountName
                        }
                    ]
                })
            }else{
                splitedRows = creditRows.map(col => {
                    let debitRowHead = getGrorpedTitle(debitRows[0].accountName, groupedData);
                    let creditRowHead = getGrorpedTitle(col.accountName, groupedData);
                    let {indirectMethod, directMethod} = getCFSMethodsInfo(debitRows[0].accountName, col.accountName ,masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData);

                    return [
                        {
                            ...col,
                            ...debitRowHead,
                            debit: Math.round(col.credit),
                            credit: "",
                            accountName: debitRows[0].accountName,
                            indirectMethod,
                            directMethod
                        },
                        {
                            ...col,
                            ...creditRowHead
                        }
                    ]
                })
            }
        }else{
            // M-M entries 

            debitRows = debitRows.map((col)=>{
                let debitRowHead = getGrorpedTitle(col.accountName, groupedData);
                return {
                    ...debitRowHead,
                    ...col
                }
            })
            creditRows = creditRows.map((col)=>{
                let creditRowHead = getGrorpedTitle(col.accountName, groupedData);
                return {
                    ...creditRowHead,
                    ...col
                }
            })
            // check entry data in saved MMMsplitentries
            splitedRows = [];
            if(MMMSplitSavedEntries?.length > 0){
                MMMSplitSavedEntries?.forEach((MMEntry, index)=>{
                    // if(MMEntry.journalId === JournalEntry[0][1].id){ // matching the journal id
                     let debitRowsChecks = debitRows.length === MMEntry.debitRows.length && debitRows.every((debitRow, indexx) => !!MMEntry.debitRows.find(item => item?.accountName === debitRow?.accountName && Number(item.debit) === Number(debitRow?.debit)))
                     let creditRowsChecks = creditRows.length === MMEntry.creditRows.length && creditRows.every((creditRow, indexx) => !!MMEntry.creditRows.find(item => item?.accountName === creditRow?.accountName && Number(item.credit) === Number(creditRow?.credit)))
                        if(!!debitRowsChecks && !!creditRowsChecks){
                            // console.log("MMM data matched", MMEntry);
                            const splitBy = MMEntry.manualSplitData.splitBy; // manual split method
                            if(splitBy === "byDebits"){
                                MMEntry.manualSplitData.splitedData.forEach((entry)=> {
                                    entry.creditRows.filter(item => !!item?.dividedAmount).forEach((creditRow)=>{
                                        let {indirectMethod, directMethod} = getCFSMethodsInfo(entry.debitRow.accountName, creditRow.accountName ,masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData);

                                        splitedRows.push([
                                          {
                                            ...entry?.debitRow,
                                            debit: Number(creditRow?.dividedAmount?.toString().replace(/,/g, '')).toFixed(2),
                                            indirectMethod,
                                            directMethod
                                          },{
                                            ...creditRow,
                                            credit: Number(creditRow?.dividedAmount?.toString().replace(/,/g, '')).toFixed(2)
                                          }
                                        ])
                                    })
                                })
                            }else{
                                MMEntry?.manualSplitData?.splitedData?.forEach((entry)=> {
                                    entry?.debitRows?.filter(item => !!item?.dividedAmount)?.forEach((debitRow)=>{
                                        let {indirectMethod, directMethod} = getCFSMethodsInfo(debitRow?.accountName, entry?.creditRow?.accountName, masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData);
                                        
                                        splitedRows.push([
                                          {
                                            ...debitRow,
                                            debit: Number(debitRow?.dividedAmount?.toString().replace(/,/g, '')).toFixed(2),
                                            indirectMethod,
                                            directMethod
                                          },{
                                            ...entry?.creditRow,
                                            credit: Number(debitRow?.dividedAmount?.toString().replace(/,/g, '')).toFixed(2)
                                          }
                                        ])
                                    })
                                })
                            }

                        }else{
                            // console.log("MMM data not matched", MMEntry);
                        }
                    // }
                })
            }
        }
        
        return{
            isSplited: !!splitedRows.length ? true :  false,
            transactionType,
            number,
            debitRows,
            creditRows,
            splitedRows,
            journalId: JournalEntry[0][1].id,
            index: index+1
        }
    })

    let uniqeEntiesArray = [];
    let customIndex =0;
    // unique entries functionality
    modifiedData.forEach((JournalEntry, index)=>{
        const { debitRows, creditRows } = JournalEntry;
        if(JournalEntry.debitRows.length === 1 && JournalEntry.creditRows.length === 1){
            // Single Single functionality
            const debitRow = debitRows[0];
            const creditRow = creditRows[0];
            // console.log(uniqeEntiesArray)
            const existingEntry = uniqeEntiesArray.length > 0 ? uniqeEntiesArray.find(entry => entry?.debitRows[0]?.accountName === debitRow.accountName && entry?.creditRows[0]?.accountName === creditRow.accountName) : null;
            if(!!existingEntry){
                uniqeEntiesArray = uniqeEntiesArray.map((entry)=>{
                    if(entry.debitRows[0].accountName === debitRow.accountName && entry.creditRows[0].accountName === creditRow.accountName && entry.debitRows.length === 1 && entry.creditRows.length === 1){
                        return {
                            ...entry,
                            count: entry.count+1,
                            debitRows: [{
                                ...entry.debitRows[0],
                                credit: "",
                                date: "-",
                                debit: (Number(entry.debitRows[0].debit) + Number(debitRow.debit)).toFixed(2),
                            }],
                            creditRows: [{
                                ...entry.creditRows[0],
                                credit: (Number(entry.creditRows[0].credit) + Number(creditRow.credit)).toFixed(2),
                                debit: "",
                                date: "-",
                            }],                     
                            splitedRows: [
                                [{
                                    ...entry.splitedRows[0][0],
                                    debit: (Number(entry.debitRows[0].debit) + Number(debitRow.debit)).toFixed(2)
                                },
                                {
                                    ...entry.splitedRows[0][1],
                                    credit: (Number(entry.creditRows[0].credit) + Number(creditRow.credit)).toFixed(2),
                                }]
                            ],
                            allEntries: [...entry.allEntries, JournalEntry],
                            // index:index+1,  
                        }
                    }else{
                        return {...entry};
                    }
                })
            }else{
                customIndex +=1;
                uniqeEntiesArray.push({count: 1, ...JournalEntry, index:customIndex, allEntries: [JournalEntry]})
            }
        }
        else if (JournalEntry.debitRows.length === 1 && JournalEntry.creditRows.length > 1){
            // Handle single debit and multiple credit rows functionality
            const debitRow = debitRows[0];
            // const totalCredit = creditRows.reduce((sum, row) => sum + Number(row.credit), 0);
            const creditRowsProcessed = creditRows.map(row => ({
                ...row,
                debit: "",
                date: "-",
            }));

            const existingEntry = uniqeEntiesArray.find(entry => 
                entry.debitRows[0]?.accountName === debitRow.accountName &&
                entry.creditRows.every((creditRow, index) => creditRows.find((cRow) => cRow?.accountName === creditRow?.accountName))
            );

            if (existingEntry) {
                uniqeEntiesArray = uniqeEntiesArray.map(entry => {
                    if (entry.debitRows[0].accountName === debitRow.accountName &&
                        entry.creditRows.length === creditRows.length &&
                        entry.creditRows.every((creditRow, index) => creditRows.find((cRow) => cRow?.accountName === creditRow?.accountName))) {
                        
                        return {
                            ...entry,
                            count: entry.count + 1,
                            debitRows: [{
                                ...entry.debitRows[0],
                                credit: "",
                                date: "-",
                                debit: (Number(entry.debitRows[0].debit) + Number(debitRow.debit)).toFixed(2),
                            }],
                            creditRows: entry.creditRows.map((creditRow, index) => ({
                                ...creditRow,
                                credit: (Number(creditRow.credit) + Number(creditRows.find((cRow) => cRow?.accountName === creditRow?.accountName)?.credit || 0)).toFixed(2),
                            })),
                            splitedRows: entry.splitedRows.map((splitRow, index) => (
                                [
                                    {   
                                        ...splitRow[0],
                                        debit: (Number(creditRows.find((cRow) => cRow?.accountName === entry.creditRows[index]?.accountName)?.credit || 0) + Number(entry.creditRows[index]?.credit || 0)).toFixed(2),
                                        date: "-"

                                    },
                                    {
                                        ...splitRow[1],
                                        credit: (Number(creditRows.find((cRow) => cRow?.accountName === entry.creditRows[index]?.accountName)?.credit || 0) + Number(entry.creditRows[index].credit || 0)).toFixed(2),
                                        date: "-"
                                    }
                                ]
                            )),
                            allEntries: [...entry.allEntries, JournalEntry],
                        };
                    } else {
                        return entry;
                    }
                });
            } else {
                customIndex += 1;
                uniqeEntiesArray.push({
                    count: 1,
                    ...JournalEntry,
                    index: customIndex,
                    allEntries: [JournalEntry],
                    creditRows: creditRowsProcessed,
                });
            }
        }
        else if (JournalEntry.debitRows.length > 1 && JournalEntry.creditRows.length === 1){
            const creditRow = creditRows[0];
            // const totalDebit = debitRows.reduce((sum, row) => sum + Number(row.debit), 0);
            const debitRowsProcessed = debitRows.map(row => ({
                ...row,
                credit: "",
                date: "-",
            }));

            const existingEntry = uniqeEntiesArray.find(entry => 
                entry.creditRows[0]?.accountName === creditRow.accountName &&
                entry.debitRows.every((debitRow, index) => debitRows.find((dRow) => dRow?.accountName === debitRow?.accountName))
            );

            if (existingEntry) {
                uniqeEntiesArray = uniqeEntiesArray.map(entry => {
                    if (entry.creditRows[0].accountName === creditRow.accountName &&
                        entry.debitRows.length === debitRows.length &&
                        entry.debitRows.every((debitRow, index) => debitRows.find((dRow) => dRow?.accountName === debitRow?.accountName))) {
                        
                        return {
                            ...entry,
                            count: entry.count + 1,
                            creditRows: [{
                                ...entry.creditRows[0],
                                debit: "",
                                date: "-",
                                credit: (Number(entry.creditRows[0].credit) + Number(creditRow.credit)).toFixed(2),
                            }],
                            debitRows: entry.debitRows.map((debitRow, index) => ({
                                ...debitRow,
                                debit: (Number(debitRow.debit) + Number(debitRows.find((dRow) => dRow?.accountName === debitRow?.accountName)?.debit || 0)).toFixed(2),
                            })),
                            splitedRows: entry.splitedRows.map((splitRow, index) => (
                                [
                                    {   
                                        ...splitRow[0],
                                        debit: (Number(debitRows.find((dRow) => dRow?.accountName === entry.debitRows[index].accountName)?.debit || 0) + Number(entry.debitRows[index]?.debit || 0)).toFixed(2),
                                        date: "-"
                                    },
                                    {
                                        ...splitRow[1],
                                        credit: (Number(debitRows.find((dRow) => dRow?.accountName === entry.debitRows[index].accountName)?.debit || 0) + Number(entry.debitRows[index]?.debit || 0)).toFixed(2),
                                        date: "-"
                                    }
                                ]
                            )),
                            allEntries: [...entry.allEntries, JournalEntry],
                        };
                    } else {
                        return entry;
                    }
                });
            } else {
                customIndex += 1;
                uniqeEntiesArray.push({
                    count: 1,
                    ...JournalEntry,
                    index: customIndex,
                    allEntries: [JournalEntry],
                    debitRows: debitRowsProcessed,
                });
            }
        }
        else{
            // customIndex +=1;
            // uniqeEntiesArray.push({count: 1, ...JournalEntry, index:customIndex,})
            // Handle multiple debit and multiple credit rows
            const debitRowsProcessed = debitRows.map(row => ({ ...row, credit: "", date: "-" }));
            const creditRowsProcessed = creditRows.map(row => ({ ...row, debit: "", date: "-" }));

            const existingEntry = uniqeEntiesArray.find(entry => 
                entry.debitRows.length === debitRows.length &&
                entry.creditRows.length === creditRows.length &&
                entry.debitRows.every(debitRow => debitRows.find(dRow => dRow?.accountName === debitRow?.accountName)) &&
                entry.creditRows.every(creditRow => creditRows.find(cRow => cRow?.accountName === creditRow?.accountName))
            );

            if (existingEntry) {
                uniqeEntiesArray = uniqeEntiesArray.map(entry => {
                    if (entry.debitRows.length === debitRows.length &&
                        entry.creditRows.length === creditRows.length &&
                        entry.debitRows.every(debitRow => debitRows.find(dRow => dRow?.accountName === debitRow?.accountName)) &&
                        entry.creditRows.every(creditRow => creditRows.find(cRow => cRow?.accountName === creditRow?.accountName))) {

                        return {
                            ...entry,
                            count: entry.count + 1,
                            debitRows: entry.debitRows.map((debitRow, index) => ({
                                ...debitRow,
                                debit: (Number(debitRow.debit) + Number(debitRows.find(item => item.accountName === debitRow.accountName)?.debit || 0)).toFixed(2),
                                credit: "",
                                date: "-"
                            })),
                            creditRows: entry.creditRows.map((creditRow, index) => ({
                                ...creditRow,
                                credit: (Number(creditRow.credit) + Number(creditRows.find(item => item.accountName === creditRow.accountName)?.credit || 0)).toFixed(2),
                                debit: "",
                                date: "-"
                            })),
                            splitedRows: entry.splitedRows.map((splitRow, index) => [
                                {
                                    ...splitRow[0],
                                    debit: Number(splitRow[0].debit || 0).toFixed(2),
                                    date: "-"
                                },
                                {
                                    ...splitRow[1],
                                    credit:  (Number(splitRow[0].debit || 0)).toFixed(2),
                                    date: "-"
                                }
                            ]),
                            allEntries: [...entry.allEntries, JournalEntry],
                        };
                    } else {
                        return entry;
                    }
                });
            } else {
                customIndex += 1;
                uniqeEntiesArray.push({
                    count: 1,
                    ...JournalEntry,
                    index: customIndex,
                    allEntries: [JournalEntry],
                    debitRows: debitRowsProcessed,
                    creditRows: creditRowsProcessed,
                });
            }
        }
    })

    let finalData = entriesType === "uniqueEntries" ? uniqeEntiesArray : modifiedData;
    let multiMutliEntriesContainer = finalData.filter((JournalEntry, index) => !JournalEntry.isSplited);
    let unmatchedEntries = finalData.filter((JournalEntry, index) => JournalEntry.isSplited &&  JournalEntry.splitedRows.some(row  => row[0]?.indirectMethod.find(innerRow => innerRow?.title === ""))).map((item)=>({...item, isGrouped:false}));
    let matchedEntries = finalData.filter((JournalEntry, index) => JournalEntry.isSplited &&  JournalEntry.splitedRows.every(row  => row[0]?.indirectMethod.every(innerRow => innerRow?.title !== ""))).map((item)=>({...item, isGrouped:true}));
    // console.log("modifiedData", modifiedData);
    
    return [
        ...multiMutliEntriesContainer,
        ...unmatchedEntries,
        ...matchedEntries
    ];
}
export const groupingLevels = [
    {name: "accountName-subHead", type:"subHead-subHead"},
    {name: "accountName-head", type:"head-head"},
    {name: "subHead-subHead", type:"subHead-subHead"},
    {name: "subHead-head", type:"subHead-head"},
    {name: "head-subHead", type:"head-subHead"},
    {name: "head-head", type:"head-head"},
]

function getCFSMethodsInfo (debitAccountName, creditAccountName, masterGroupingRow, cfsGroupingjson, cfsIndirectTemplateJson, cfsDirectTemplateJson, groupedData) {
    if(!masterGroupingRow) return 
    // console.log(debitAccountName," - ", creditAccountName, groupedData)
    const debitRow =  getGrorpedTitle(debitAccountName, groupedData);
    const creditRow =  getGrorpedTitle(creditAccountName, groupedData)
    let levelInfo = ""
    
    const findIndirectCapHandler = () => {

        const debitCap = "debitCaption";
        const creditCap = "creditCaption";
        let methodEntry = undefined;
        const getAlternateCaptions = (row, masterGroupingRow) => 
            masterGroupingRow.find(item => item.row.trim().toLowerCase() === row.trim().toLowerCase())?.alternateCaptions || [];
        groupingLevels.forEach((level, levelIndex)=>{
            if(!methodEntry){
                let cfsGroupingfilteredjson = cfsGroupingjson.filter(item => item.type === level.type);
                if(level.name === "accountName-subHead"){ // Level 1
                    // let type = "row";
                    methodEntry = cfsGroupingfilteredjson.find(grpEntry => {
                        // Extracting alternate captions for debit and credit rows
                        const debitRowCaptions = getAlternateCaptions(grpEntry[debitCap], masterGroupingRow);
                        const creditRowCaptions = getAlternateCaptions(grpEntry[creditCap], masterGroupingRow);
                        
                        // Convert splitedEntry rows to lowercase
                        // const [splitedDebitRow, splitedCreditRow] = [debitRow[type].trim().toLowerCase(), creditRow[type].trim().toLowerCase()];
                        const [splitedDebitRow, splitedCreditRow] = [debitAccountName.trim().toLowerCase(), creditAccountName.trim().toLowerCase()];
                        
                        // Check conditions for debit and credit rows
                        const isDebitMatch = grpEntry[debitCap].trim().toLowerCase() === splitedDebitRow || !!debitRowCaptions.find(row => row.toLocaleLowerCase() === splitedDebitRow);
                        
                        const isCreditMatch = grpEntry[creditCap].trim().toLowerCase() === splitedCreditRow || !!creditRowCaptions.find(row => row.toLocaleLowerCase() === splitedDebitRow);
                        
                        return isDebitMatch && isCreditMatch;
                    });
                    levelInfo = methodEntry ? "level 1" : ""
                }else if (level.name === "accountName-head"){ // level 2
                    // let type = "head";
                    methodEntry = cfsGroupingfilteredjson.find(grpEntry => {
                        // Convert splitedEntry rows to lowercase
                        const [splitedDebitRow, splitedCreditRow] = [debitAccountName.trim().toLowerCase(), creditAccountName.trim().toLowerCase()];
                        
                        // Check conditions for debit and credit rows
                        const isDebitMatch = grpEntry[debitCap].trim().toLowerCase() === splitedDebitRow;
                        
                        const isCreditMatch = grpEntry[creditCap].trim().toLowerCase() === splitedCreditRow;
                        
                        return isDebitMatch && isCreditMatch;
                    });
                    levelInfo = methodEntry ? "level 2" : ""
                }else if (level.name === "subHead-subHead" || level.name === "head-head"){ // level 3
                    let type = level.name === "subHead-subHead" ? "row" : "head";
                    methodEntry = cfsGroupingfilteredjson.find(grpEntry => {
                         // Extracting alternate captions for debit and credit rows
                        const debitRowCaptions = getAlternateCaptions(grpEntry[debitCap], masterGroupingRow);
                        const creditRowCaptions = getAlternateCaptions(grpEntry[creditCap], masterGroupingRow);
                        
                        // Convert splitedEntry rows to lowercase
                        const [splitedDebitRow, splitedCreditRow] = [debitRow[type].trim().toLowerCase(), creditRow[type].trim().toLowerCase()];
                        
                         // Check conditions for debit and credit rows
                        const isDebitMatch = grpEntry[debitCap].trim().toLowerCase() === splitedDebitRow || !!debitRowCaptions.find(row => row.toLocaleLowerCase() === splitedDebitRow);
                        
                        const isCreditMatch = grpEntry[creditCap].trim().toLowerCase() === splitedCreditRow || !!creditRowCaptions.find(row => row.toLocaleLowerCase() === splitedDebitRow);
                        
                        return isDebitMatch && isCreditMatch;
                    });
                    levelInfo = methodEntry ? level.name === "subHead-subHead" ? "level 3" : "level 6" : ""
                }else if (level.name === "subHead-head"){ // level 4
                    let type = "head";
                    methodEntry = cfsGroupingfilteredjson.find(grpEntry => {                     
                        // Extracting alternate captions for debit and credit rows
                        const debitRowCaptions = getAlternateCaptions(grpEntry[debitCap], masterGroupingRow);
                        
                        // Convert splitedEntry rows to lowercase
                        const [splitedDebitRow, splitedCreditRow] = [debitRow.row.trim().toLowerCase(), creditRow[type].trim().toLowerCase()];
                        
                        // Check conditions for debit and credit rows
                        const isDebitMatch = grpEntry[debitCap].trim().toLowerCase() === splitedDebitRow || !!debitRowCaptions.find(row => row.toLocaleLowerCase() === splitedDebitRow);
                        
                        const isCreditMatch = grpEntry[creditCap].trim().toLowerCase() === splitedCreditRow;
                        
                        return isDebitMatch && isCreditMatch;
                    });
                    levelInfo = methodEntry ? "level 4" : ""
                }else if (level.name === "head-subHead"){ // level 5
                    let type = "head";
                    methodEntry = cfsGroupingfilteredjson.find(grpEntry => {                       
                        // Extracting alternate captions for debit and credit rows
                        const creditRowCaptions = getAlternateCaptions(grpEntry[creditCap], masterGroupingRow);
                        // const debitRowCaptions = getAlternateCaptions(grpEntry[debitCap], masterGroupingRow);
                        
                        // Convert splitedEntry rows to lowercase
                        const [splitedDebitRow, splitedCreditRow] = [debitRow[type].trim().toLowerCase(), creditRow.row.trim().toLowerCase()];
                        
                        // Check conditions for debit and credit rows
                        const isDebitMatch = grpEntry[debitCap].trim().toLowerCase() === splitedDebitRow;
                        
                        const isCreditMatch = grpEntry[creditCap].trim().toLowerCase() === splitedCreditRow || !!creditRowCaptions.find(row => row.toLocaleLowerCase() === splitedCreditRow);
                        
                        return isDebitMatch && isCreditMatch;
                    });
                    levelInfo = methodEntry ? "level 5" : ""
                }
            }
        })


        return methodEntry;
    }

    const findIndirectRowId =  findIndirectCapHandler(cfsGroupingjson, 'row')
    // const findIndirectHeadId =  findIndirectCapHandler(cfsGroupingjsonHead, 'head')
    // let findIndirectRowId = cfsGroupingjson.find((grpEntry) => grpEntry.debitRow.trim().toLocaleLowerCase() === debitRow.trim().toLocaleLowerCase() && grpEntry.creditRow.trim().toLocaleLowerCase() === creditRow.trim().toLocaleLowerCase());
    // console.log("findIndirectRowId >>>", findIndirectRowId, findIndirectHeadId);
    // console.log("findIndirectRowId", findIndirectRowId);
   
    
    if(findIndirectRowId ){
        
        let emptyArray = [];
        let emptyArray1 = [];
        findIndirectRowId.toGroupIM.forEach(grpRow => {
            let isGoingToGrpUnderMain = cfsIndirectTemplateJson.find(mainRow => mainRow.id === grpRow.indirectRowId)
            let isGoingToGrpUnderChild = cfsIndirectTemplateJson.find(mainRow => {
                let found = mainRow.childrens.find(child => child.id === grpRow.indirectRowId)
                if(found){
                    emptyArray.push({...found, method: grpRow.method, methodRowId:findIndirectRowId._id, matchType: findIndirectRowId ? "row" : "head", level: levelInfo})
                    return mainRow.childrens.find(child => child.id === grpRow.indirectRowId)
                }
            })
            // console.log(debitRow, creditRow, isGoingToGrpUnderMain, isGoingToGrpUnderChild)
            if(isGoingToGrpUnderMain){
                emptyArray.push({...isGoingToGrpUnderMain, method: grpRow.method, matchType: findIndirectRowId ? "row" : "head"})
                return isGoingToGrpUnderMain
            }else if(isGoingToGrpUnderChild) {
                // emptyArray.push(isGoingToGrpUnderChild)
                return isGoingToGrpUnderChild
                // console.log("Going to group under main row child");
            }else{
                // console.log("Row or child not found");
                // return [];
            }
        })
        findIndirectRowId.toGroupDM.forEach(grpRow => {
            let isGoingToGrpUnderMain = cfsDirectTemplateJson.find(mainRow => mainRow.id === grpRow.directRowId)
            let isGoingToGrpUnderChild = cfsDirectTemplateJson.find(mainRow => {
                let found = mainRow.childrens.find(child => child.id === grpRow.directRowId)
                if(found){
                    emptyArray1.push({...found, method: grpRow.method, methodRowId:findIndirectRowId._id, level: levelInfo})
                    return mainRow.childrens.find(child => child.id === grpRow.directRowId)
                }
            })
            // console.log(debitRow, creditRow, isGoingToGrpUnderMain, isGoingToGrpUnderChild)
            if(isGoingToGrpUnderMain){
                emptyArray1.push({...isGoingToGrpUnderMain, method: grpRow.method, matchType: findIndirectRowId ? "row" : "head"})
                return isGoingToGrpUnderMain
            }else if(isGoingToGrpUnderChild) {
                // emptyArray.push(isGoingToGrpUnderChild)
                return isGoingToGrpUnderChild
                // console.log("Going to group under main row child");
            }else{
                // console.log("Row or child not found");
                // return [];
            }
        })
        
        // if(emptyArray.length === 0){
        //     return [{title: "- (Blank)"}] 
        // }else{
        //     return emptyArray
        // }

        return {
            indirectMethod: emptyArray.length === 0 ? [{title: "- (Blank)",methodRowId:findIndirectRowId._id, level: levelInfo}] : emptyArray,
            directMethod: emptyArray1.length === 0 ? [{title: "- (Blank)",methodRowId:findIndirectRowId._id, level: levelInfo}] : emptyArray1,
        }
    }
    else {
        // return [{title: ""}]
        return {
            indirectMethod: [{title: ""}],
            directMethod:[{title: ""}]
        }
    }
}

export const getBeginningBalance = (periodGlData, periodGroupedData, markupTableData) => {
    let beginningBalance = 0;
    let beginningBalanceCaptions = getCaptions("BALANCE SHEET", "CURRENT ASSETS", "Cash and cash equivalents", markupTableData);
    const caceGroupedEntries = periodGroupedData.filter(entry =>  beginningBalanceCaptions.find(caption => caption === entry.row));
    const caceGLEntries = periodGlData?.Rows?.Row?.filter(row => caceGroupedEntries.find(entry => row?.Header?.ColData?.[0].value === entry.accountName));
    
    caceGLEntries.forEach(entry => {
        // console.log(entry.Header.ColData[0].value, Number(entry?.Rows?.Row[0]?.ColData[entry?.Rows?.Row[0]?.ColData?.length-1].value || 0))
        if(entry?.Rows?.Row[0]?.ColData?.[0].value === "Beginning Balance"){
            beginningBalance += Number(entry?.Rows?.Row?.[0]?.ColData?.[entry?.Rows?.Row?.[0]?.ColData?.length-1]?.value || 0)
        }
    })

    // console.log(periodGlData, periodGroupedData, caceGroupedEntries, caceGLEntries, beginningBalance)
    return Math.round(beginningBalance);
}
export const getBeginningBalanceWithEntries = (periodGlData, caceCurrentPeriod) => {
    let beginningBalance = 0;
    // const caceGroupedEntries = periodGroupedData.filter(entry => entry.row === "Cash and cash equivalents");
    const caceGLEntries = periodGlData?.Rows?.Row?.filter(row => caceCurrentPeriod?.find(entry => row?.Header?.ColData?.[0].value === entry.title))?.map(entry => {
        // console.log(entry.Header.ColData[0].value, Number(entry?.Rows?.Row[0]?.ColData[entry?.Rows?.Row[0]?.ColData?.length-1].value || 0))
        // if(entry?.Rows?.Row[0]?.ColData[0].value === "Beginning Balance"){
            beginningBalance += entry?.Rows?.Row?.[0]?.ColData?.[0].value === "Beginning Balance" ? Number(entry?.Rows?.Row[0]?.ColData?.[entry?.Rows?.Row[0]?.ColData?.length-1].value || 0): 0;
            return {
                title: entry?.Header?.ColData?.[0].value,
                amount: Math.round(entry?.Rows?.Row?.[0]?.ColData?.[0].value === "Beginning Balance" ? Number(entry?.Rows?.Row?.[0]?.ColData[entry?.Rows?.Row?.[0]?.ColData?.length-1].value || 0): 0)
            }
        // }
    })

    // console.log("caceGLEntries >>>", {entries:caceGLEntries, total: beginningBalance})

    // console.log(periodGlData, periodGroupedData, caceGroupedEntries, caceGLEntries, beginningBalance)
    return {entries:caceGLEntries, total: Math.round(beginningBalance)};
}

export const updateOperatingCaptions = (uploadedPeriods, netIncome, getTotalOfMainRow) => {
    let caption = "Net cash provided by (used in) operating activities";

    if (uploadedPeriods?.length === 1) {
        const total = Math.round(netIncome[0] || 0) + getTotalOfMainRow(1, 'first') + getTotalOfMainRow(0, 'first');
        caption = total >= 0 ? "Net cash provided by operating activities" : "Net cash (used in) operating activities";
    } else if (uploadedPeriods?.length > 1) {
        const totalFirst = Math.round(netIncome[0] || 0) + getTotalOfMainRow(1, 'first') + getTotalOfMainRow(0, 'first');
        const totalSecond = Math.round(netIncome[1] || 0) + getTotalOfMainRow(1, 'second') + getTotalOfMainRow(0, 'second');

        if (totalFirst >= 0 && totalSecond >= 0) {
            caption = "Net cash provided by operating activities";
        } else if (totalFirst < 0 && totalSecond < 0) {
            caption = "Net cash (used in) operating activities";
        } else {
            caption = "Net cash provided by (used in) operating activities";
        }
    }

    return caption;
};

export const updateInvestingCaptions = (uploadedPeriods, getTotalOfMainRow) => {
    let caption = "Net cash provided by (used in) investing activities";

    if (uploadedPeriods?.length === 1) {
        const total = getTotalOfMainRow(2, 'first');
        caption = total >= 0 ? "Net cash provided by investing activities" : "Net cash (used in) investing activities";
    } else if (uploadedPeriods?.length > 1) {
        const totalFirst = getTotalOfMainRow(2, 'first');
        const totalSecond = getTotalOfMainRow(2, 'second');

        if (totalFirst >= 0 && totalSecond >= 0) {
            caption = "Net cash provided by investing activities";
        } else if (totalFirst < 0 && totalSecond < 0) {
            caption = "Net cash (used in) investing activities";
        } else {
            caption = "Net cash provided by (used in) investing activities";
        }
    }

    return caption;
};

export const updateFinancingCaptions = (uploadedPeriods, getTotalOfMainRow) => {
    let caption = "Net cash provided by (used in) financing activities";

    if (uploadedPeriods?.length === 1) {
        const total = getTotalOfMainRow(3, 'first');
        caption = total >= 0 ? "Net cash provided by financing activities" : "Net cash (used in) financing activities";
    } else if (uploadedPeriods?.length > 1) {
        const totalFirst = getTotalOfMainRow(3, 'first');
        const totalSecond = getTotalOfMainRow(3, 'second');

        if (totalFirst >= 0 && totalSecond >= 0) {
            caption = "Net cash provided by financing activities";
        } else if (totalFirst < 0 && totalSecond < 0) {
            caption = "Net cash (used in) financing activities";
        } else {
            caption = "Net cash provided by (used in) financing activities";
        }
    }

    return caption;
};

export const updateCACECaptions = (uploadedPeriods, netIncome, getTotalOfMainRow, type='indirect') => {
    if (!uploadedPeriods?.length) return "";
    
    const calculateSubTotal = (index, period) => {
        return (
            Math.round(netIncome[index] || 0) +
            getTotalOfMainRow(1, period) +
            getTotalOfMainRow(0, period) +
            getTotalOfMainRow(2, period) +
            type === 'indirect' ? getTotalOfMainRow(3, period) : 0
        );
    };

    if (uploadedPeriods.length === 1) {
        const subTotal = calculateSubTotal(0, 'first');
        return subTotal >= 0 ? "Net increase in cash and cash equivalents" : "Net (decrease) in cash and cash equivalents";
    }
    
    if (uploadedPeriods.length > 1) {
        const subTotalFirst = calculateSubTotal(0, 'first');
        const subTotalSecond = calculateSubTotal(1, 'second');
        
        if (subTotalFirst >= 0 && subTotalSecond >= 0) {
            return "Net increase in cash and cash equivalents";
        } else if (subTotalFirst < 0 && subTotalSecond < 0) {
            return "Net (decrease) in cash and cash equivalents";
        } else {
            return "Net increase (decrease) in cash and cash equivalents";
        }
    }
    
    return "Net increase (decrease) in cash and cash equivalents";
};

export const updateNetIncomeCaption = (uploadedPeriods, netIncome) => {
    if (!uploadedPeriods?.length) return "";
    
    const calculateSubTotal = (index) => {
        return (
            Math.round(netIncome?.[index] || 0)
        );
    };

    if (uploadedPeriods.length === 1) {
        const subTotal = calculateSubTotal(0);
        return subTotal >= 0 ? "Net income" : "Net (loss)";
    }
    
    if (uploadedPeriods.length > 1) {
        const subTotalFirst = calculateSubTotal(0);
        const subTotalSecond = calculateSubTotal(1);
        
        if (subTotalFirst >= 0 && subTotalSecond >= 0) {
            return "Net income";
        } else if (subTotalFirst < 0 && subTotalSecond < 0) {
            return "Net (loss)";
        } else {
            return "Net income (loss)";
        }
    }
    
    return "Net income";
};

export const addPeriodInData = (data = [], period, type) => {
    const updatedData = data?.map(item => ({...item, period}));
    return updatedData
}

export const simplifyData = (data) => {
    const tableData = [];
    data?.forEach((item, ind) => {
        let indirectDataArr = []
        let directDataArr = []
        const periodOneRows = item?.splitedRows?.periodOne || [];
        const periodTwoRows = item?.splitedRows?.periodTwo || [];
        // console.log("periodOne>>>>", {periodOneRows, periodTwoRows})
        const methodItemsLength = Math.max(periodOneRows.length, periodTwoRows.length);
        Array(methodItemsLength).fill()?.forEach((splitItem, splitIndex) => {
            const periodOneIndirectMethods = item?.splitedRows?.periodOne[splitIndex]?.[0]?.indirectMethod || [];
            const periodOneDirectMethods = item?.splitedRows?.periodOne[splitIndex]?.[0]?.directMethod || [];
            const periodTwoIndirectMethods = item?.splitedRows?.periodTwo[splitIndex]?.[0]?.indirectMethod || [];
            const periodTwoDirectMethods = item?.splitedRows?.periodTwo[splitIndex]?.[0]?.directMethod || [];
            
            const maxIndirectMethod = Math.max(periodOneIndirectMethods.length, periodTwoIndirectMethods.length);
            const maxDirectMethod = Math.max(periodOneDirectMethods.length, periodTwoDirectMethods.length);
            
            const periodOneSplitedRow = item?.splitedRows["periodOne"]?.[splitIndex]?.[0];
            const periodTwoSplitedRow = item?.splitedRows["periodTwo"]?.[splitIndex]?.[0];
            // console.log("maxLengths", {maxIndirectMethod, maxDirectMethod})
            
            Array(maxIndirectMethod).fill()?.forEach((_, ind) => {
                let indirectData = {};
                const pOneIndMethod = item?.splitedRows["periodOne"]?.[splitIndex]?.[0].indirectMethod?.[ind];
                const pTwoIndMethod = item?.splitedRows["periodTwo"]?.[splitIndex]?.[0].indirectMethod?.[ind];

                indirectData.periodOneDebit= pOneIndMethod?.title !== "- (Blank)" ? periodOneSplitedRow?.debit : "";
                indirectData.periodOneDate= pOneIndMethod?.title !== "- (Blank)" ? periodOneSplitedRow?.date : "";
                indirectData.periodTwoDebit= pTwoIndMethod?.title !== "- (Blank)" ? periodTwoSplitedRow?.debit || "" : "";
                indirectData.periodTwoDate= pTwoIndMethod?.title !== "- (Blank)" ? periodTwoSplitedRow?.date || "" : "";
                indirectData.creditRow =  {...(periodOneRows?.[splitIndex]?.[1] || periodTwoRows?.[splitIndex]?.[1])};
                indirectData.insiSuggestion = (pOneIndMethod || pTwoIndMethod)?.insiSuggestion ? {...(pOneIndMethod || pTwoIndMethod)?.insiSuggestion} : {...(pOneIndMethod || pTwoIndMethod)};
                indirectData.accountName= (pOneIndMethod?.title || pTwoIndMethod?.title) !== "- (Blank)" ? (periodOneSplitedRow || periodTwoSplitedRow)?.accountName : "";
                indirectData={...indirectData, ...(pOneIndMethod || pTwoIndMethod)};
                indirectDataArr.push(indirectData)
            })
            
            Array(maxDirectMethod).fill()?.forEach((_, ind) => {
                let directData = {};
                const pOneDirMethod = item?.splitedRows["periodOne"]?.[splitIndex]?.[0].directMethod?.[ind];
                const pTwoDirMethod = item?.splitedRows["periodTwo"]?.[splitIndex]?.[0].directMethod?.[ind];

                directData.periodOneDebit= pOneDirMethod?.title !== "- (Blank)" ? periodOneSplitedRow?.debit : "";
                directData.periodOneDate= pOneDirMethod?.title !== "- (Blank)" ? periodOneSplitedRow?.date : "";
                directData.periodTwoDebit= pTwoDirMethod?.title !== "- (Blank)" ? periodTwoSplitedRow?.debit : "";
                directData.periodTwoDate= pTwoDirMethod?.title !== "- (Blank)" ? periodTwoSplitedRow?.date : "";
                directData.accountName= (pOneDirMethod?.title || pTwoDirMethod?.title) !== "- (Blank)" ? (periodOneSplitedRow || periodTwoSplitedRow)?.accountName : "";
                directData.insiSuggestion = (pOneDirMethod || pTwoDirMethod)?.insiSuggestion ? {...(pOneDirMethod || pTwoDirMethod)?.insiSuggestion} : {...(pOneDirMethod || pTwoDirMethod)};
                directData={...directData, ...(pOneDirMethod || pTwoDirMethod)};
                directData.creditRow =  {...(periodOneRows?.[splitIndex]?.[1] || periodTwoRows?.[splitIndex]?.[1])};
                directDataArr.push(directData)
            })
        });
        const itemData = {
            ...item,
            indirectDataArr,
            directDataArr
        }
        tableData.push(itemData)
    })

    return tableData;
}

export const calculatePeriodTotals = (journal) => {
    const periods = ["periodOne", "periodTwo"];

    const result = {};
  
    periods.forEach(period => {
      // sum debit rows
      const debitTotal = (journal.debitRows || []).reduce((sum, row) => {
        const val = Math.round((+row[period]?.debit || 0) * 100);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
  
      // sum credit rows
      const creditTotal = (journal.creditRows || []).reduce((sum, row) => {
        const val = Math.round((+row[period]?.credit || 0) * 100);
        return sum + (isNaN(val) ? 0 : Number(val));
      }, 0);
  
      // final difference
      result[`${period}Total`] = (debitTotal - creditTotal) / 100
    });

    return result;
}
// Single definition of "unclassified" for the CFS "Below entries could not be auto-classified"
// warning - shared by CFSWorksheet, CFSIndirect and CFSDirect so the three can't drift apart.
// cfsMethod: "indirectMethod" | "directMethod".
export const getUnclassifiedCfsEntries = (entries, cfsMethod) => {
    if (!entries) return { multiMutliEntries: [], unmatchedEntries: [] };
    // M-M entries not yet split by the user (a manual split sets isMMMSelected, not isSplited).
    const multiMutliEntries = entries.filter(entry => !entry?.isSplited && !entry?.isMMMSelected);
    // Split entries with at least one row still missing a caption for this method.
    const unmatchedEntries = entries.filter(entry =>
        entry?.isSplited &&
        entry?.debitRows?.some(row =>
            Object.values(row?.cfsMethodInfo || {}).some(periods =>
                periods?.some(info => info?.[cfsMethod]?.some(innerRow => innerRow?.title === ""))
            )
        )
    );
    return { multiMutliEntries, unmatchedEntries };
};
